import { createTheme, DEFAULT_THEME } from "@mantine/core";

import { colors } from "./colors";
import { fontSizes } from "./fontSizes";
import { fontWeight } from "./fontWeights";
import { headings } from "./headings";
import { radius } from "./radius";
import { shadows } from "./shadows";
import { spacing } from "./spacing";

export const theme = createTheme({
  ...DEFAULT_THEME,
  colors,
  headings,
  radius,
  spacing,
  shadows,

  fontFamily: "Roboto, sans-serif",
  black: "#000000",
  primaryColor: "blue",
  defaultRadius: "sm",
  other: {
    fontWeights: fontWeight,
    fontSizes: fontSizes,
  },
  components: {
    Image: {
      styles: {
        root: {
          flex: 0,
        },
      },
    },
    Grid: {
      defaultProps: {
        gap: "xs",
      },
      styles: {
        root: {
          margin: 0,
          borderStyle: "none",
        },
        col: {
          paddingRight: spacing.xxs,
        },
      },
    },
    Text: {
      defaultProps: {
        size: "sm",
      },
    },
    ActionIcon: {
      defaultProps: {
        variant: "subtle",
        color: "gray",
      },
      styles: {
        root: {
          "&:hover": {
            backgroundColor: colors.gray[2],
          },
        },
      },
    },
  },
});
